export default {
  // ProfileChangeSecurityQuestionsDialog must remain this way because it's in bootstrap data.
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_1:
    "What is the name of your favorite sports team?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_2:
    "What is the middle name of your youngest child?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_3:
    "What was the color of your first car?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_4:
    "What is your favorite ice cream flavor?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_5:
    "What is the name of your first pet?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_6:
    "What is the name of the city in which you were born?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_7:
    "What is the name of your favorite movie?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_8:
    "What is the name of your favorite singer/band?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_9:
    "What is your mother's maiden name?",
  ProfileChangeSecurityQuestionsDialog__UPDATE_SECURITY_QUESTION_OPTION_10:
    "What was your high school mascot?",
  SecurityQuestionsFormField__ARIA_LABEL: "Aria label for Security Questions Form Field",
  SecurityQuestionsFormField__CAPTION: "Caption for Security Questions Form Field",
  SecurityQuestionsFormField__LABEL: "Security Questions",
  SecurityQuestionsFormField__SECURITY_ANSWER_1: "Security answer 1",
  SecurityQuestionsFormField__SECURITY_ANSWER_2: "Security answer 2",
  SecurityQuestionsFormField__SECURITY_QUESTION_1: "Security question 1",
  SecurityQuestionsFormField__SECURITY_QUESTION_2: "Security question 2",
  SecurityQuestionsFormField__SELECT: "Select",
  SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_1: "Select security question 1.",
  SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_2: "Select security question 2.",
};
